import { create } from 'zustand';
import { saveAs } from 'file-saver';
import { ApiUtils } from '@shared/utils';
import { CardsApi, type DownloadInvoicesRequest } from '@shared/api';

interface UseDownloadInvoicesStore {
  loadingIds: Set<string>;
  data: boolean | null;
  error: string | null;
  downloadInvoice: (request: DownloadInvoicesRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadInvoicesStore = create<UseDownloadInvoicesStore>((set) => ({
  loadingIds: new Set<string>(),
  data: null,
  error: null,

  downloadInvoice: async (request, signal) => {
    try {
      set((state) => ({ loadingIds: new Set(state.loadingIds).add(request.id), data: null, error: null }));
      const result = await CardsApi.downloadInvoice(request.id, signal);
      saveAs(result.data, request.name);
      set({ data: true });
    } catch (error) {
      set({ data: false, error: ApiUtils.getApiError(error) });
    } finally {
      set((state) => {
        const loadingIds = new Set(state.loadingIds);
        loadingIds.delete(request.id);
        return { loadingIds };
      });
    }
  },

  clear: () => set({ loadingIds: new Set<string>(), data: null, error: null }),
}));
